/**
 * This is the main implementation of the navigation component, only
 * missing the bits that require MooTools for implementation (those
 * are implemented in `./navigation` and passed into this component as
 * props.
 */
import { _js } from '@ifixit/utils/localize';
import { FaIcon } from '@ifixit/ui/components/icon';
import { trackAnalyticsCustomEvent } from '@ifixit/analytics';

export function Navigation({ links, heading, pageTitle, onIfixit, isLoggedIn, tabsOnly }: any) {
   const visibleTabs = links.tabLinks.filter((tab: any) => tab.showTab);
   const headingText = heading ?? pageTitle;

   function getActiveTabIndex() {
      let index = 0;
      while (index < visibleTabs.length) {
         const tab = visibleTabs[index];
         if (tab.label === pageTitle) {
            break;
         }
         index++;
      }
      return index;
   }

   const activeTabIndex = getActiveTabIndex();
   const currentTabData = visibleTabs[activeTabIndex];
   const activeValue = visibleTabs[activeTabIndex]?.label ?? '';

   return (
      <div id="communityNav" className="mt-6">
         <nav aria-label={_js('Community')}>
            {/* `py-1` is room for the tabs' focus ring, which the scroll
                box clips without it; `-my-1` gives it back, so the strip and
                its underline stay put. See `tabs.tsx`. */}
            <div className="scroll-fade-x -my-1 flex items-center py-1">
               {visibleTabs.map((tab: any) => (
                  <a
                     key={tab.label}
                     href={tab.url}
                     aria-current={tab.label === activeValue ? 'page' : undefined}
                     className="relative inline-flex min-w-[120px] flex-1 shrink-0 items-center justify-center whitespace-nowrap border-gray-200 border-b-2 px-5 py-2 font-semibold text-gray-500 text-sm no-underline transition-colors hover:border-gray-400 hover:text-gray-600 hover:no-underline focus-visible:outline-none focus-visible:ring-[3px] focus-visible:ring-ring/50 aria-[current=page]:border-brand-500 aria-[current=page]:text-brand-500"
                  >
                     {tab.label}
                  </a>
               ))}
            </div>
         </nav>
         {/* tabsOnly: the page's own React body renders the H1 and help
             link, so the strip is all this component contributes. */}
         {tabsOnly ? null : (
            <header className="mt-6 flex flex-wrap items-center justify-center md:justify-between">
               <h1 className="mb-1.5 w-full text-[30px] font-medium text-gray-800 md:mb-0 md:w-auto">
                  {headingText}
               </h1>
               <div className="hidden flex-auto flex-wrap justify-end gap-2 md:flex md:gap-4">
                  {onIfixit && (
                     <a
                        href={currentTabData?.help}
                        className="inline-flex items-center gap-2 rounded-md px-3 py-2 text-sm font-medium text-gray-700 hover:bg-gray-100"
                        onClick={() => {
                           trackAnalyticsCustomEvent({
                              eventCategory: pageTitle,
                              eventAction: `${pageTitle} - Btn "How this Works"`,
                              eventName: currentTabData?.help,
                           });
                        }}
                     >
                        {_js('How this Works')}
                        <FaIcon name="circle-info" className="size-4" />
                     </a>
                  )}
                  {!isLoggedIn && (
                     <a
                        href="/Join"
                        className="buttonLink inline-block"
                        onClick={() => {
                           trackAnalyticsCustomEvent({
                              eventCategory: pageTitle,
                              eventAction: `${pageTitle} - Btn - Join`,
                           });
                        }}
                     >
                        {_js('Join')}
                     </a>
                  )}
               </div>
            </header>
         )}
      </div>
   );
}
